import { Button, Modal, ModalContent, ModalFooter, ModalProps, ModalTitle, Toggle } from '@dashboard/ui'
import { useTranslation } from 'react-i18next'
import { dashboardClient } from '@/api'
import { StoreGraph } from '@/api/dashboard'
import { useGenerateCompanyPath } from '@/libs'
import { useForm } from 'react-hook-form'

interface StoreGraphSettingsModalProps extends ModalProps {
  storeGraph: StoreGraph
  onGraphChange: (anonymous_allowed: boolean | null | undefined) => void
}

export const StoreGraphSettingsModal = (props: StoreGraphSettingsModalProps) => {
  const { t } = useTranslation()
  const { ...rest } = props
  const { companyId, gameId } = useGenerateCompanyPath()

  const {
    handleSubmit,
    watch,
    setValue,
    formState: { isSubmitting },
  } = useForm<StoreGraph>({
    values: {
      ...props.storeGraph,
    },
  })

  const useForAnonymous = watch('anonymous_allowed')

  const onFormSubmit = async (data: StoreGraph) => {
    await dashboardClient.v1.createOrUpdateStoreGraph(companyId, gameId, {
      anonymous_allowed: data.anonymous_allowed,
    })

    props.onGraphChange(data.anonymous_allowed)
    props.onClose()
  }

  return (
    <Modal {...rest}>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <ModalContent>
          <ModalTitle>{t('store-graph.settings')}</ModalTitle>
          <div className="flex justify-between">
            <span className="text-caption-md text-text-tertiary">{t('store-graph.anonymous_allowed')}</span>
            <Toggle
              size="sm"
              checked={useForAnonymous}
              onChange={e => {
                setValue('anonymous_allowed', e.target.checked, { shouldDirty: true })
              }}
            />
          </div>
        </ModalContent>
        <ModalFooter>
          <Button size="sm" onClick={props.onClose} variant="outline" color="secondary">
            {t('Cancel')}
          </Button>

          <Button size="sm" type="submit" loading={isSubmitting}>
            {t('Save')}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
